export const reduxKey = '@@publicSession';

//# sourceMappingURL=constants.js.map